
export default {

  setClients (state, clients) {
    state.all = clients
  },

  setClientAddresses (state, addresses) {
    state.addresses = addresses
  },

  setClientCatalog (state, catalog) {
    state.catalog = catalog
  },

  setCurrentClient (state, client) {
    state.current = client
  },

  setCurrentId (state, id) {
    state.currentId = id
  }
}